import { bookingAvailabilityReducerState } from "./bookingAvailabilityTypes";
import { bookingAvailabilityActionTypes } from "./bookingAvailabilityTypes";

// conversationReducer.ts

const initialState: bookingAvailabilityReducerState = {
    available_rooms: [
        // {
        //     room_id: "1",
        //     room_number: "102",
        //     room_type: "STD AC",
        //     max_pax: "2",
        //     phone_inquiry: "+3",
        //     walking_inquiry: "+1",
        //     price: "2200",
        //     range: "2500 - 2200",
        // },
    ],
    booked_rooms: [],
    loading: false,
    error: null,
};

const bookingAvailabilityReducer = (state = initialState, action: any): bookingAvailabilityReducerState => {
    switch (action.type) {
        case bookingAvailabilityActionTypes.API_RESPONSE_SUCCESS:
            if (!action.payload?.actionType) {
                console.error(
                    `API_RESPONSE_SUCCESS: Missing actionType in payload. Action type: ${action.type}, Payload:`, action.payload
                );
                throw new Error(
                    `Reducer error: Missing actionType in payload for API_RESPONSE_SUCCESS. Action: ${JSON.stringify(action)}`
                );
            }

            switch (action.payload.actionType) {

                case bookingAvailabilityActionTypes.GET_AVAILABLE_ROOMS:
                    console.log("[bookingAvailabilityReducer.ts] GET_AVAILABLE_ROOMS success case triggred", action.payload);

                    return {
                        ...state,
                        available_rooms: action.payload.data.available_rooms || [],
                        booked_rooms: action.payload.data.booked_rooms || [],
                        // approvalSuccess: action.payload.data.isSuccess,
                        // guests: [],
                        loading: false
                        // intent: action.payload.data.intent,
                        // uiComponent: action.payload.data.uiComponent,
                        // agentLogId: action.payload.data.agent_log_id,
                        // missingFields: action.payload.data.missingFields
                        // isRoomListLoading: true,
                        // errorMessage: "",
                    };



                // Cases to be inserted later
                default:
                    return {
                        ...state,
                    };
            }

        case bookingAvailabilityActionTypes.API_RESPONSE_ERROR:
            if (!action.payload?.actionType) {
                console.error(
                    `API_RESPONSE_ERROR: Missing actionType in payload. Action type: ${action.type}, Payload:`, action.payload
                );
                throw new Error(
                    `Reducer error: Missing actionType in payload for API_RESPONSE_ERROR. Action: ${JSON.stringify(action)}`
                );
            }

            switch (action.payload.actionType) {

                case bookingAvailabilityActionTypes.GET_AVAILABLE_ROOMS:
                    console.log("[bookingAvailabilityReducer.ts] GET_AVAILABLE_ROOMS errror case triggred", action.payload);

                    return {
                        ...state,
                        // approvalSuccess: false,
                        loading: false,
                        error: "Apologies! Something went wrong"
                        // intent: null,
                        // uiComponent: null,
                        // agentLogId: null,
                        // missingFields: null
                        // isRoomListLoading: true,
                        // errorMessage: "",
                    };



                // Cases to be inserted later
                default:
                    return {
                        ...state,
                    };
            }



        case bookingAvailabilityActionTypes.GET_AVAILABLE_ROOMS:
            console.log("[bookingAvailabilityReducer.ts] GET_AVAILABLE_ROOMS pre api case triggred", action.payload);

            return {
                ...state,

                loading: true,
                error: null
                // userUtterance: action.payload.transcript
                // isRoomListLoading: true,
                // errorMessage: "",
            };
        // pre api cases
        default:
            return state;
    }
};


export default bookingAvailabilityReducer;
